import React, { useMemo, useState } from 'react';
// @ts-ignore
import styles from './ActionCenterConversationListItem.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import { useAppContext } from '../../../../Services/AppContext';
import { joinClasses } from '../../../../Utils/className.util';
import Text from '../../../../Components/Base/Text/Text';
import ActionCenterMessageDetailModal from '../ActionCenterMessageDetail/ActionCenterMessageDetailModal';
import { ActionCenterConversationListItemScheme } from '../../Interfaces/ActionCenterConversationListItem.interface';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import FormattedDate from '../../../../Components/FormattedDate';

interface Props {
	item: ActionCenterConversationListItemScheme;
	showSender?: boolean;
}

const PREVIEW_LIMIT = 100;

const ActionCenterConversationListItem: React.FC<Props> = ({
	item,
	showSender = false,
}) => {
	const { t } = useTranslation();
	const { dateFormatMoment } = useAppContext();
	const [isDetailOpen, setIsDetailOpen] = useState(false);

	const name: string = useMemo(() => {
		if (showSender) {
			return item?.sender?.user?.profile?.fullName;
		}
		let name = item?.singleRecipient?.user?.profile?.fullName;
		if (item.totalRecipients > 1) {
			name += ` (+${item.totalRecipients - 1} ${t('base.next')})`;
		}
		return name;
	}, []);

	const handleOpenDetail = () => {
		setIsDetailOpen(true);
	};

	return (
		<>
			<div className={styles.wrapper} onClick={handleOpenDetail}>
				<div className={styles.name}>{name}</div>
				<div className={styles.content}>
					{!item?.myMessageMember?.seen && (
						<Text
							className={joinClasses([styles.badge, styles.red])}
							tx='base.shared.new'
							firstUpper
							inline
						/>
					)}
					<span className={styles.subject}>{item?.conversation?.name}</span> -{' '}
					{item?.content?.text.slice(0, PREVIEW_LIMIT) + '... '}
				</div>
				{item?.messageAttachments.length > 0 && (
					<div className={styles.attachment}>
						<img src='/dist/icons/v2/paperclip-solid.svg' />
					</div>
				)}
				<div className={styles.date}>
					<FormattedMomentDate
						date={item.createdAt}
						format={DateFormat.DATE_TIME}
					/>
				</div>
			</div>
			{isDetailOpen && (
				<ActionCenterMessageDetailModal
					isOpen={isDetailOpen}
					onClose={() => setIsDetailOpen(false)}
					conversationId={item.conversation.id}
				/>
			)}
		</>
	);
};

export default ActionCenterConversationListItem;
